// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plugNetIncomeMessage1{
position: relative;
bottom: 18px;
margin-left: 30px;
font-size: 12px !important;
}

.text-position-pnp{
    position: relative;
    top:-19px;
}

.text-position{
    position: relative;
    top: 1px;
}

:host ::ng-deep .p-datatable > .p-datatable-wrapper {
    overflow: unset; 
}


.scroll {
    overflow: auto;
    max-height: 250px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
